import React from 'react';
import StyledButton from '../styles/PaginationButton';
import PropTypes from 'prop-types';

const PaginationButton = ({ pageNumber, disabled, handleClick }) => (
    <StyledButton
        onClick={handleClick}
        disabled={disabled}
        className={disabled ? 'stolo-pager-notclickable stolo-pager-active' : ''}
    >
        {pageNumber}
    </StyledButton >
    );

PaginationButton.defaultProps = ({
    disabled: false,
});

PaginationButton.propTypes = {
    pageNumber: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
    handleClick: PropTypes.func.isRequired,
};

export default PaginationButton;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PaginationButton.js